import {registerRoute as workbox_routing_registerRoute} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-routing@7.0.0/node_modules/workbox-routing/registerRoute.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-strategies@7.0.0/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-core@7.0.0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-precaching@7.0.0/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-precaching@7.0.0/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-routing@7.0.0/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from '/home/adamscott/dev/builds/gd-web/node_modules/.pnpm/workbox-precaching@7.0.0/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "assets/client-c781d100.js",
    "revision": null
  },
  {
    "url": "assets/demo-9f3f6fe1.css",
    "revision": null
  },
  {
    "url": "assets/demo-f7ac4503.js",
    "revision": null
  },
  {
    "url": "assets/dist-JOLMFQSE-78eed63f.js",
    "revision": null
  },
  {
    "url": "assets/dist-LKHVF5W7-95d4e1f1.js",
    "revision": null
  },
  {
    "url": "assets/dist-SFRFRGE3-2bd06938.js",
    "revision": null
  },
  {
    "url": "assets/GdExercise-6ef49038.css",
    "revision": null
  },
  {
    "url": "assets/GdExercise-be6e505c.js",
    "revision": null
  },
  {
    "url": "assets/gdquest-logo-dark-d5790a4a.svg",
    "revision": null
  },
  {
    "url": "assets/gdquest-logo-light-71d329d3.svg",
    "revision": null
  },
  {
    "url": "assets/loader-40814945.css",
    "revision": null
  },
  {
    "url": "assets/loader-9a6dfd57.js",
    "revision": null
  },
  {
    "url": "assets/size-95169cc0.js",
    "revision": null
  },
  {
    "url": "demo.html",
    "revision": "9f2c7617383f56edc863da2dd1f20783"
  },
  {
    "url": "exercises/godot-practice-framework.zip",
    "revision": "0c5786efc06cddf1a88d03a6ad22e25e"
  },
  {
    "url": "favicon.png",
    "revision": "535cb68d085e558ee8baeab53fc4b197"
  },
  {
    "url": "godot.editor.audio.worklet.js",
    "revision": "0f147ff6c4b7d53f0d66d591aeada8b6"
  },
  {
    "url": "godot.editor.html",
    "revision": "62910be9664a0365598e442e78c6f1dc"
  },
  {
    "url": "godot.editor.js",
    "revision": "ac6547989fffcf0bfb2a2373eb5c5765"
  },
  {
    "url": "godot.editor.wasm",
    "revision": "62aa99c3cfc651d8c9c50d1a0481791e"
  },
  {
    "url": "godot.editor.worker.js",
    "revision": "9465017f99d00531e2a5a3dad30598ba"
  },
  {
    "url": "loader.html",
    "revision": "2266a9449b29fca7b7df1a56c5b10d20"
  },
  {
    "url": "logo.svg",
    "revision": "00f8e06a4025502a3d5c5acb4c648bd6"
  },
  {
    "url": "offline.html",
    "revision": "e76efda1fe9995bcf9028d0e21deb3ce"
  },
  {
    "url": "projects/2d-character-completed.zip",
    "revision": "b2f5b38924dfa022a6c47820ec073a9c"
  },
  {
    "url": "projects/2d-project-completed.zip",
    "revision": "86cda7620109939b15ded468eae33198"
  },
  {
    "url": "projects/3d-project-completed.zip",
    "revision": "28f1ae04c614cc78df57322065440017"
  },
  {
    "url": "projects/blank.zip",
    "revision": "dcb537d5b7ab2f89c71a4459500b1643"
  },
  {
    "url": "projects/getting-started-with-godot-4.zip",
    "revision": "8e3449cbb485d7b99c7f441dbe4e9802"
  },
  {
    "url": "projects/snippet.zip",
    "revision": "60ef8be8e5748fba3856d5539f69ee3f"
  },
  {
    "url": "registerSW.js",
    "revision": "402b66900e731ca748771b6fc5e7a068"
  },
  {
    "url": "service.worker.js",
    "revision": "5534880e7711653acabe0a27de301250"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "27e3f25b4afe9e8d2b0467ed55d91269"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();
workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("index.html")));


workbox_routing_registerRoute(/godot\.editor\.(?:js|wasm|(?:(?:audio\.worklet|worker)\.js))/, new workbox_strategies_StaleWhileRevalidate(), 'GET');




